import { render, staticRenderFns } from "./investors-panel--inactive.vue?vue&type=template&id=7a9d5964&scoped=true&"
import script from "./investors-panel--inactive.vue?vue&type=script&lang=ts&"
export * from "./investors-panel--inactive.vue?vue&type=script&lang=ts&"
import style0 from "./investors-panel--inactive.vue?vue&type=style&index=0&id=7a9d5964&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a9d5964",
  null
  
)

export default component.exports